import(/* webpackMode: "eager" */ "/var/www/apporb-web/frontend/src/app/forgot-password/page.tsx");
